
    import './styles.scoped.css';
    export default {
  "marker": "awsui_marker_1kjc7_ql8bm_93",
  "root": "awsui_root_1kjc7_ql8bm_111",
  "title": "awsui_title_1kjc7_ql8bm_125",
  "list": "awsui_list_1kjc7_ql8bm_129",
  "marker--dimmed": "awsui_marker--dimmed_1kjc7_ql8bm_151",
  "marker--highlighted": "awsui_marker--highlighted_1kjc7_ql8bm_154",
  "marker--focused": "awsui_marker--focused_1kjc7_ql8bm_157"
};
  